import SetupRequestList from './SetupRequestList';
import SetupRequestEdit from './SetupRequestEdit';
import * as urls from './urls';
import * as utils from './utils';
import { RestrictedPage } from "routes/CrudRoute";


export const EPaymentResources = [
  {
    "name": utils.setupRequestResourceName,
    "frontendPath": urls.setupRequestFrontendPath,
    "backendPath": urls.setupRequestBackendPath,
    "list": SetupRequestList,
    "showInSideMenu": true,
  },
];

export const EPaymentCustomRoutes = [
  {
    "name": "Add new shop",
    "frontendPath": urls.setupRequestEditFrontendPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SetupRequestEdit, "E-Payment Setup Request", {
      "resource": utils.setupRequestResourceName,
      "redirectPath": urls.setupRequestFrontendPath,
    })
  },
];


// WEBPACK FOOTER //
// ./src/routes/e_payment/resources.js